export default "__VITE_PUBLIC_ASSET__1826da0c__"